const template = `
	<p class="nm-el-pg nm-el-pg-03">{{=window.i18n['carstore-layer.no-slots-available']}}</p>
`;
export {template as carstoreEmptyTemplate};
